/*
 * Copyright (c) 2020. American Express Company
 */

import _ from 'lodash';
import { FullUserModel, UserUtils } from 'src/types/user.model';
import { ReduxAction } from '../helpers';
import { FETCH_USER_PENDING, FETCH_USER_SUCCESS, FETCH_USER_ERROR, SET_USER } from '../types';

export interface UserState {
    user?: FullUserModel;
}

const initialState = {
    pending: false,
    payload: null as FullUserModel,
    error: null as any
};

export default function user(state = initialState, action: ReduxAction<FullUserModel>): any {
    switch (action.type) {
        case SET_USER: {
            const user = action.payload;
            return {
                ...state,
                user
            };
        }
        case FETCH_USER_PENDING:
            return {
                ...state,
                pending: true
            };
        case FETCH_USER_SUCCESS:
            const user =
                action.payload && _.isString(action.payload.dob)
                    ? UserUtils.deserializeDates(action.payload)
                    : action.payload;
            return {
                ...state,
                pending: false,
                user
            };
        case FETCH_USER_ERROR:
            return {
                ...state,
                pending: false,
                error: action.error
            };
        default:
            return state;
    }
}
